import React, { useState, useCallback, useEffect } from "react";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import {  getClientContracts, postCustomerISCCDocument, putCustomerISCCDocument, getCustomerISCCDocumentById } from "net/contracts";
import { useDispatch, useSelector } from "react-redux";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import {  Row, Col } from "react-grid-system";
import "views/contractView/styles/newElementFormStyles.css";
import { DatePicker, Button, InputAttach } from "@ds/ds-snam/react";
import {  useNavigate, useParams } from "react-router-dom";
import { DATE_FORMAT, RoutePath,  DocumentType, EntityType, DsLayout, ResponseStatus, ResponseCode, BadgeStatus, FormMode, AppUserRole, IAppUserProfile } from "shared/constants";
import {  IDocument, ICustomerIscc } from "dataModels/contract";
import { FileStatusEnum, IFileUpload } from "dataModels/fileInput";
import moment from "moment";
import DSFileInput from "components/DSFileInput";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { showNotification, hideNotification } from "state/reducer/notificationSlice";
import { useTranslation } from "react-i18next";
import { DSFile } from "@ds/ds-snam";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { RootState } from "state/appStore";
import { Select, Input as TextInput } from "@ds/ds-snam/react";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";



interface MyISelectLabel extends ISelectLabel{
    maxBookableSlots?:string
}

const getDefaultFormData = (): ICustomerIscc => {
    const defaultFormData: ICustomerIscc = {
        id: "", 
        businessId: "",
        documents:[
            {
                type: DocumentType.CUSTOMER_ISCC_DOCUMENT,
                name: "",
                size: 0,
                content: "",
                expire: Math.floor(Date.now() / 1000),
                status: BadgeStatus.TOAPPROVE
            }
        ]
    }
    return defaultFormData;
}



const CustomerISCCDocumentForm: React.FC = (): JSX.Element => {
    const [formStep, setFormStep] = useState<number>(0);
    const { t } = useTranslation(['contract','app']);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formError, setFormError] = useState<boolean>(false);
    const { businessId, id } = useParams(); //contractId esiste solo se sono in edit
    const [formMode, setFormMode] = useState<number>(id ? FormMode.EDIT : FormMode.NEW);
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    

    const [formData, setFormData] = useState<ICustomerIscc>(getDefaultFormData());

    useEffect(()=>{
        formData.businessId = businessId||"";
        console.log("businessId", businessId);
        console.log("id", id);
        if(formMode===FormMode.EDIT && id){
            dispatch(requestPending());
            getCustomerISCCDocumentById(id)
                .then((response) => {
                    if(response.data && appUserRole!==AppUserRole.SALES_PROFILE && appUserRole!==AppUserRole.ADMIN){
                        response.data.documents[0].status=BadgeStatus.TOAPPROVE;
                    }else{
                        response.data.documents[0].status=BadgeStatus.APPROVED;
                    }
                    console.log("response.data formData",formData);
                    setFormData(response.data);
                    console.log("response.data",response.data);
                    console.log("response.data formData",formData);
                })
                .catch(error => {
                    
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                })
                
            }
            
    },[])



    const validateStep = () => {

        if(formData.documents.length===0 || formData.documents[0].name===''){
            return 1;
        }else{
            return 0;
        }
        
    }

    const onDateInputChange = (inputEvent: Event) => {
        const date: string = (inputEvent as CustomEvent).detail.dateSelection;
        if(formData.documents[0]!==null){
            formData.documents[0].expire = moment.utc(date, DATE_FORMAT).unix();
        }
    }

    const saveFormData = useCallback(() => {
        dispatch(requestPending());
        console.log("saveFormData",id);
        if (id && id!==null){
            putCustomerISCCDocument(formData)
            .then((response) => {
                //gestione errori business
                const popUpTitle:string = response.status===ResponseStatus.ERROR ? 'Error':(response.code===ResponseCode.UNPROCESSABLE_CONTENT? "Warning": t("transporter.isccDocumentForm.popupTitle") );
                const popUpDescription:string = response.status===ResponseStatus.ERROR||response.code===ResponseCode.UNPROCESSABLE_CONTENT?response.message:t("transporter.isccDocumentForm.popupText");
                const popUpStatus:NotificationsStatusType = response.status===ResponseStatus.ERROR?"error":(response.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
                                
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
            })
            .catch(error => {
                const popUpTitle:string = 'Error';
                const popUpDescription:string ="error";
                const popUpStatus:NotificationsStatusType = "error";
                                
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
        } else {
        postCustomerISCCDocument(formData)
            .then((response) => {
                //gestione errori business
                const popUpTitle:string = response.status===ResponseStatus.ERROR ? 'Error':(response.code===ResponseCode.UNPROCESSABLE_CONTENT? "Warning": t("transporter.isccDocumentForm.popupTitle") );
                const popUpDescription:string = response.status===ResponseStatus.ERROR||response.code===ResponseCode.UNPROCESSABLE_CONTENT?response.message:t("transporter.isccDocumentForm.popupText");
                const popUpStatus:NotificationsStatusType = response.status===ResponseStatus.ERROR?"error":(response.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
                                
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
            })
            .catch(error => {
                const popUpTitle:string = 'Error';
                const popUpDescription:string ="error";
                const popUpStatus:NotificationsStatusType = "error";
                                
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.CONTRACTS_CUSTOMER_INFO);
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
        }
               
    }, [ dispatch, navigate,formData]);

    return (

        <>

                <Row>
                    <Col>
                        <div className="formSubTitle">
                            {t("customer.customerIsccDocumentForm.sub_title_1")}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="fileInputWrapper">
                            <DSFileInput
                                key={id && formData.documents[0].name ? id : "new"}
                                title={t("customer.customerIsccDocumentForm.sub_title_2")}
                                inputLabel={formData.documents.length ? t('dsComponents.fileInput.defaultStatus.title', {ns:'app'}) : t('contract.contractForm.sections.fileInput.unloadedFile')}
                                id="doc0"
                                accept="application/pdf, image/jpg, image/jpeg"
                                maxSize={10000000}
                                defaultStatus={formData.documents[0].name !== '' ? FileStatusEnum.UPLOADED : FileStatusEnum.DEFAULT}
                                onFileUpload={(fileUpload: IFileUpload, id: string) => {
                                    console.log("formData",formData);
                                    
                                    let currentFormData = { ...formData };
                                    console.log("currentFormData",currentFormData);
                                    let base64String = btoa(fileUpload.content);
                                    const documentObj: IDocument = {
                                        type: DocumentType.CUSTOMER_ISCC_DOCUMENT,//"securityTemplate",
                                        name: fileUpload.name,
                                        size: fileUpload.size,
                                        content: base64String,
                                        expire: moment(formData.documents[0].expire, DATE_FORMAT).unix(),
                                        status: appUserRole===(AppUserRole.SALES_PROFILE||appUserRole===AppUserRole.ADMIN)?BadgeStatus.APPROVED:BadgeStatus.TOAPPROVE
                                    }
                                    currentFormData.documents[0] = documentObj;
                                    console.log("currentFormData",currentFormData);
                                    setFormData(currentFormData);
                                    console.log("formData",formData);
                                }}
                            />
                        </div>
                        </Col>
                        </Row>
                        <Row>
                        {formData.documents[0].name !== '' ?
                            <div className="uploadedFileWrapper" style={{paddingLeft:'16px'}}>
                                <InputAttach
                                    attachName={formData.documents[0].name}
                                    firstButtonDisabled={false}
                                    secondButtonDisabled={false}
                                    inputLabel={t('contract.contractForm.sections.fileInput.attachTitle')}//"File caricato"
                                />
                            </div>
                            :
                            <></>
                        }
                        {formData.documents[0].name &&
                            <Col xs={12} md={3}>
                                <div className="expirationInputWrapper" style={{width:'196px'}}>
                                    <DatePicker
                                        id="scadenzaDoc"
                                        datePickerTitle={t("transporter.isccDocumentForm.expire")}//"scadenza"
                                        isRangePicker={false}
                                        datePickerVariant="full-date"
                                        datePickerPlaceholder=""
                                        startingYear={new Date().getFullYear()}
                                        endingYear={2099}
                                        defaultDate={formData.documents[0].expire ? moment.unix(formData.documents[0].expire).toDate() : new Date()}
                                        isDisabled={false}
                                        datePickerStatus="default"
                                        confirmButtonLabel="Conferma"
                                        disabledDates={{ lastDisabledDate: new Date(Date.now() - 86400000) }} 
                                        hasCloseButton={false}
                                        zIndex={999}
                                        isReadonly={false}
                                        isPanelTop={true}
                                        onDateSelection={(event: Event) => {
                                            onDateInputChange(event)
                                        }}
                                    ></DatePicker>
                                </div>
                            </Col>
                        }</Row>
                        <Row>
                            <Col>
                    </Col>
                </Row>





            {!formError && <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.8rem" }}>
                <Button
                    style={{ marginRight: "0.8rem" }}
                    id="backButton"
                    buttonType="button"
                    buttonUIVariant="secondary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.back', { ns: 'app' })}//"Indietro"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={()=>{navigate(RoutePath.CONTRACTS_CUSTOMER_INFO+"/"+businessId);}}
                />
                <Button
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.confirm', { ns: 'app' })}//"Conferma"
                    buttonIcon=""
                    isDisabled={validateStep()!==0}
                    onClickEvent={(event: Event) => {
                        console.log(formData)
                        let errors = validateStep();
                        if(errors===0){
                            saveFormData();
                        }
                    }}
                />
            </div>}
            
        </>
    )
}
export default CustomerISCCDocumentForm;